var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3105 7.475L11.043 6.207L11.75 5.5L13.8715 7.6215L14.225 7.975L11.75 10.45L11.043 9.7425L12.3105 8.475H7V7.475H12.3105ZM9 15H2.003C1.87131 15.0001 1.74089 14.9742 1.61921 14.9238C1.49752 14.8735 1.38695 14.7996 1.2938 14.7066C1.20066 14.6135 1.12677 14.5029 1.07636 14.3813C1.02595 14.2596 1 14.1292 1 13.9975V2.0025C1 1.449 1.4485 1 2.003 1H9V2H2.5035C2.43786 1.99947 2.37276 2.01189 2.31193 2.03654C2.25109 2.06118 2.19571 2.09758 2.14895 2.14364C2.10219 2.18971 2.06496 2.24454 2.03941 2.305C2.01385 2.36546 2.00046 2.43036 2 2.496V13.504C2 13.7725 2.225 14 2.5035 14H9V15Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 1,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 3,
    height: 1,
    rx: 0.5,
    transform: "rotate(90 11 1)",
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 3,
    height: 1,
    rx: 0.5,
    transform: "rotate(90 11 12)",
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjMxMDUgNy40NzVMMTEuMDQzIDYuMjA3TDExLjc1IDUuNUwxMy44NzE1IDcuNjIxNUwxNC4yMjUgNy45NzVMMTEuNzUgMTAuNDVMMTEuMDQzIDkuNzQyNUwxMi4zMTA1IDguNDc1SDdWNy40NzVIMTIuMzEwNVpNOSAxNUgyLjAwM0MxLjg3MTMxIDE1LjAwMDEgMS43NDA4OSAxNC45NzQyIDEuNjE5MjEgMTQuOTIzOEMxLjQ5NzUyIDE0Ljg3MzUgMS4zODY5NSAxNC43OTk2IDEuMjkzOCAxNC43MDY2QzEuMjAwNjYgMTQuNjEzNSAxLjEyNjc3IDE0LjUwMjkgMS4wNzYzNiAxNC4zODEzQzEuMDI1OTUgMTQuMjU5NiAxIDE0LjEyOTIgMSAxMy45OTc1VjIuMDAyNUMxIDEuNDQ5IDEuNDQ4NSAxIDIuMDAzIDFIOVYySDIuNTAzNUMyLjQzNzg2IDEuOTk5NDcgMi4zNzI3NiAyLjAxMTg5IDIuMzExOTMgMi4wMzY1NEMyLjI1MTA5IDIuMDYxMTggMi4xOTU3MSAyLjA5NzU4IDIuMTQ4OTUgMi4xNDM2NEMyLjEwMjE5IDIuMTg5NzEgMi4wNjQ5NiAyLjI0NDU0IDIuMDM5NDEgMi4zMDVDMi4wMTM4NSAyLjM2NTQ2IDIuMDAwNDYgMi40MzAzNiAyIDIuNDk2VjEzLjUwNEMyIDEzLjc3MjUgMi4yMjUgMTQgMi41MDM1IDE0SDlWMTVaIiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjciIHk9IjEiIHdpZHRoPSI0IiBoZWlnaHQ9IjEiIHJ4PSIwLjUiIGZpbGw9IiMzMzMzMzMiLz4KPHJlY3QgeD0iMTEiIHk9IjEiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIHJ4PSIwLjUiIHRyYW5zZm9ybT0icm90YXRlKDkwIDExIDEpIiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjExIiB5PSIxMiIgd2lkdGg9IjMiIGhlaWdodD0iMSIgcng9IjAuNSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTEgMTIpIiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjciIHk9IjE0IiB3aWR0aD0iNCIgaGVpZ2h0PSIxIiByeD0iMC41IiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };